import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Modal, Flex } from 'dash-ui';

import MortgageForm from 'pages/Dashboard/components/MortgageCalculatorWidget/components/MortgageForm/MortgageForm';
import MortgageChart from 'pages/Dashboard/components/MortgageCalculatorWidget/components/MortgageModal/components/MortgageChart';

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
};

const Container = styled(Flex)`
  flex-direction: row;
  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
  }
`;
const ChartContainer = styled(Flex)`
  border-left: 1px solid ${({ theme }) => theme.colors.n20};
  @media ${({ theme }) => theme.devices.mobile} {
    border-left: unset;
  }
`;
const ModalStyle = styled(Modal)`
  &.MortgageModal__content {
    @media ${({ theme }) => theme.devices.desktop} {
      padding-bottom: 0;
      width: 928px;
    }
    @media ${({ theme }) => theme.devices.tablet} {
      width: 100%;
      margin: 0 16px;
    }
  }
`;

const MortgageModal = ({ isOpen, onRequestClose }: Props) => {
  const { t } = useTranslation(['pages', 'common']);
  return (
    <ModalStyle
      closeIcon
      withDevider
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      className="MortgageModal"
      title={t('pages:dashboardPage.mortgageWidget.mortgageModalTitle') || ''}
    >
      <Container>
        <Flex pr={4} flex={1} justifyContent="column">
          <MortgageForm />
        </Flex>
        <ChartContainer w="100%" flex={2}>
          <MortgageChart />
        </ChartContainer>
      </Container>
    </ModalStyle>
  );
};

export default MortgageModal;
